import react, { useEffect, useState, useRef } from 'react'
import axios from 'axios';
import _ from 'lodash';
import { useHistory } from "react-router-dom";
import { SortableContainer, SortableElement } from 'react-sortable-hoc';

let words = ["Sit down", "Stand up", "Write"]
const baseurl = process.env.REACT_APP_FRONT_LINK;

function DragAndDrop(props) {


    const intr = useRef(null);


    const arrayMoveMutable = (array, fromIndex, toIndex) => {
        const startIndex = fromIndex < 0 ? array.length + fromIndex : fromIndex;

        if (startIndex >= 0 && startIndex < array.length) {
            const endIndex = toIndex < 0 ? array.length + toIndex : toIndex;

            const [item] = array.splice(fromIndex, 1);
            array.splice(endIndex, 0, item);
        }
        return array;
    }
    const SortableItem = SortableElement(({ value, index2 }) => <div style={{ position: "relative" }} className="blue-border"><div
        style={

            {
                position: "absolute",
                background: "white",
                color: "#0B329D",
                top: -12,
                left: -5,
                width: 30,
                height: 30,
                borderRadius: "100%",
                fontFamily: 'fredokaone',
                fontWeight: "normal",
                fontSize: 20,
                display: "flex",
                alignItems: "center",
                justifyContent: "center"
            }
        }>{index2 + 1}</div>
        <img src={baseurl + value.img} />
        <div style={{ color: "red", fontFamily: "gotham-medium", color: "#0B329D", textAlign: "center", width: "100%", fontSize: 18, minHeight: 50 }}>{value.text}</div>
    </div>);

    const SortableList = SortableContainer(({ items }) => {
        return (
            <div className="sort-item" style={{ display: "flex", alignItems: "center", flexDirection: "row", margin: "auto", width: "100%" }}>
                {items.map((value, index) => (
                    <SortableItem key={`item-${value}`} index={index} index2={index} value={value} />
                ))}
            </div>
        );
    });


    const [currentDrag, setCurrentDrag] = useState({});
    const [userSelect, setUserSelect] = useState({});
    const history = useHistory();

    const [items, setItems] = useState([
        {
            id: "1",
            img: baseurl + "assets/levels/level1/rev2/story/item2.png",
            text: "Muzzy travels in his spaceship."
        },
        {
            id: "2",
            img: baseurl + "assets/levels/level1/rev2/story/item3.png",
            text: "Muzzy looks for clocks."
        },
        {
            id: "3",
            img: baseurl + "assets/levels/level1/rev2/story/item1.png",
            text: "Muzzy eats a parking meter."
        }
    ]);

    const [randList, setRandList] = useState([]);


    const shuffle = (array) => {
        let currentIndex = array.length, randomIndex;

        // While there remain elements to shuffle...
        while (currentIndex != 0) {

            // Pick a remaining element...
            randomIndex = Math.floor(Math.random() * currentIndex);
            currentIndex--;

            // And swap it with the current element.
            [array[currentIndex], array[randomIndex]] = [
                array[randomIndex], array[currentIndex]];
        }

        return array;
    }
    const checkQuestion = () => {

        let answerFormat = {
            pass: true,
            progress: 0,
            questionTitle: props.questions.title,
            userAnswers: [],
            type: "sorting-pictures"
        }

        let answers_data = document.querySelectorAll(".blue-border img");

        if (JSON.stringify(randList) === JSON.stringify(items)) {

            answers_data.forEach((answer_item) => {
                answer_item.style.border = "6px solid #83cd83";
            })

            document.getElementById("correct-au").play();

            answerFormat.pass = true;
        } else {

            answers_data.forEach((answer_item) => {
                answer_item.style.border = "6px solid red";
            })

            document.getElementById("wrong-au").play();

            answerFormat.pass = false;
        }

        let userType = localStorage.getItem("userType");

        if (userType === "teacher") {
            // teacher: do not advance automatically
        } else {

            setTimeout(() => {
                props.nextExercise(answerFormat);
            }, 3000);
        }
    }

    useEffect(() => {

        setItems(props.questions.mainItems)

        let currentItems = [...props.questions.mainItems];

        currentItems = shuffle(currentItems);

        setRandList(currentItems);

        setTimeout(() => {
            intr.current.play();
        }, 300)

    }, [])

    const playIntr = (e) => {
        //  document.getElementById("intr").play();
    }

    const onSortEnd = ({ oldIndex, newIndex }) => {
        let items = [...randList];
        items = arrayMoveMutable(items, oldIndex, newIndex);
        setRandList(items)
    }

    const videoPlay = (e) => {
        document.getElementById("video-lin").play();
        document.getElementById("video-waf").style.display = "none";
    }


    return (<div style={{ width: "70%" }}>
        <div className="question-title-container">
            <div style={{ display: "flex", alignItems: "center", gap: "20px" }}>
                <img style={{ opacity: 0 }} ssrc={baseurl + "assets/game5/listen.svg"} />
                <h1 className="question-title" dangerouslySetInnerHTML={{ __html: props.questions.title }}></h1>

            </div>
            <div style={{ opacity: 0 }} id="audio-bt" onClick={playIntr}><img src={baseurl + "assets/audio/listen.png"} /></div>
        </div>

        {/* <audio src={`${baseurl}assets/audio/p4/p1.wav`} className="hidden-audio" id="intr" ref={intr} /> */}

        <audio src={baseurl + props.questions.audio} className="hidden-audio" id="intr" ref={intr} />

        <audio src={`${baseurl}assets/audio/correct.mp3`} className="hidden-audio" id="correct-au" />
        <audio src={`${baseurl}assets/audio/wrong.mp3`} className="hidden-audio" id="wrong-au" />

        {/* <div className="video-intro" style={{height: "30vh",width: "30vw",margin: "0 auto 50px"

                }}><video id="video-lin" src={baseurl + "assets/video1.mp4"} controls /></div> */}
        <SortableList onSortEnd={onSortEnd} items={randList} axis={"x"} />
        {/* <SortableContainer style={{display:"flex",alignItems:"center",flexDirection:"row",margin:"auto"}}>
            {randList.map((randItem) => {
                return);
            })}
        </SortableContainer> */}
        <div className="button-check">
            <button className="check-answer-bt" variant="contained" color="primary" onClick={checkQuestion}>Check my answer</button>

        </div>


    </div>)
}
export default DragAndDrop;